import { render, staticRenderFns } from "./page_row.vue?vue&type=template&id=afbaae5e&scoped=true&lang=pug"
import script from "./page_row.vue?vue&type=script&lang=js"
export * from "./page_row.vue?vue&type=script&lang=js"
import style0 from "./page_row.vue?vue&type=style&index=0&id=afbaae5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbaae5e",
  null
  
)

export default component.exports